import en from '../i18n/langs/en' // 英语
import cn from '../i18n/langs/cn' // 中文
import Storage from '@/utils/storage'

const langDict = {
    "en": en,
    "cn": cn,
}
export function getLangDict() {
    let lang = Storage.get('lang');
    if(lang){
        return langDict[lang.lang]
    }
    return langDict['cn'];
}

// 导航中英文切换
export function getLangMenu(title) {
    const hasKey = this.$te('menu.' + title)
    const translatedTitle = this.$t('menu.' + title) // $t :this method from vue-i18n, inject in @/lang/index.js
    if (hasKey) {
        return translatedTitle
    }
    return title
}